import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(scrollTrigger);

export class CallToAction {
	constructor() {
		this.callToAction = document.querySelectorAll(".call-to-action-block");

		this.callToAction.forEach((block) => {
			this.scrollAnimation(block);
		});
	}

	scrollAnimation(block) {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			return;
		}

		const background = block.querySelector(".call-to-action-block__background");

		const tl = gsap
			.timeline({
				scrollTrigger: {
					trigger: block,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
				},
				defaults: {
					ease: "none",
					duration: 1,
				},
			})

			.fromTo(
				background,
				{
					yPercent: -25,
				},
				{
					yPercent: 25,
				}
			);
	}
}
